import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export function RequireAuth({ children }) {
  const { isAuthenticated, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="card p-4 text-sm text-slate-600">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

export function RequireAdmin({ children }) {
  const { isAdmin, checking } = useAuth();

  if (checking) {
    return (
      <div className="card p-4 text-sm text-slate-600">
        Loading...
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export function RequireRole({ allowedRoles, children }) {
  const { user, checking } = useAuth();

  if (checking) return <div className="card p-4 text-sm text-slate-600">Loading...</div>;

  if (!user || !allowedRoles.includes(user.role)) {
    // If kasir tries to access non-kasir page, redirect to /events.
    // If accountant tries to access non-accountant page, redirect to /accountant/dashboard.
    // Else redirect to /
    if (user?.role === "kasir") return <Navigate to="/events" replace />;
    if (user?.role === "accountant") return <Navigate to="/accountant/dashboard" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}
